import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const NetworkIssue: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M14.74 5c-.3 0-.53.24-.53.53v10.56c0 .3.23.53.53.53h2.1c.3 0 .54-.24.54-.53V5.53c0-.3-.24-.53-.53-.53h-2.11Zm-1.59 3.3a.4.4 0 0 0-.47-.4A18.4 18.4 0 0 0 3 12.8l-.08.08a.41.41 0 0 0-.01.58l2.35 2.45c.16.17.42.17.58.02l.09-.08a14.18 14.18 0 0 1 6.89-3.66.4.4 0 0 0 .33-.4V8.3Zm5.75-.4a.4.4 0 0 0-.47.4v3.48c0 .2.14.37.34.41 2.57.55 4.95 1.8 6.89 3.66l.08.08c.17.15.43.15.59-.02l2.35-2.45a.41.41 0 0 0-.01-.58l-.09-.08a18.4 18.4 0 0 0-9.68-4.9Zm-5.75 6.9a.4.4 0 0 0-.5-.4 12.07 12.07 0 0 0-5.26 2.97l-.09.08a.41.41 0 0 0 0 .58l2.36 2.46c.15.17.42.17.58.02l.08-.08a7.95 7.95 0 0 1 2.56-1.66.43.43 0 0 0 .27-.39V14.8Zm5.78-.4a.4.4 0 0 0-.5.4v3.58c0 .18.11.33.27.4.94.37 1.8.92 2.56 1.65l.08.08c.17.15.43.15.59-.02l2.36-2.46a.41.41 0 0 0-.01-.58l-.08-.08a12.07 12.07 0 0 0-5.27-2.97Zm-5.78 6.55c-.5.26-.96.59-1.38.99l-.08.08a.41.41 0 0 0-.01.58l3.81 3.98c.17.17.44.17.6 0l3.82-3.98a.41.41 0 0 0-.02-.58l-.08-.08c-.41-.4-.88-.73-1.38-.99a2.75 2.75 0 0 1-2.6 2.3c-1.21 0-2.33-.65-2.68-2.3Z"
    />
    <path
      fill="currentColor"
      d="M17.47 20.27a1.65 1.65 0 1 1-3.3 0 1.65 1.65 0 0 1 3.3 0Z"
    />
  </Icon>
);
